"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardList = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
require("./card-list.scss");
const CardList = (props) => {
    const { className, children, minWidth, minWidthMobile, maxWidth = '100%' } = props;
    const classNames = (0, classnames_1.default)('card-list', className !== null && className !== void 0 ? className : '');
    const styles = (0, react_1.useRef)({
        '--card-min-width': minWidth,
        '--card-min-width-mobile': minWidthMobile !== null && minWidthMobile !== void 0 ? minWidthMobile : minWidth,
        '--card-max-width': maxWidth,
    });
    return (react_1.default.createElement("div", { className: classNames, style: styles.current }, children));
};
exports.CardList = CardList;
//# sourceMappingURL=CardList.js.map